import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PharmHeader } from '../pharm-header/pharm-header';
import { PharmSidebar } from '../pharm-sidebar/pharm-sidebar';
import { DatePipe, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

const baseUrl = 'https://logs.proofile.com.ng/api';

@Component({
  selector: 'app-pharmacist-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, DatePipe, PharmHeader, PharmSidebar],
  templateUrl: './pharmacist-dashboard.html',
  styleUrl: './pharmacist-dashboard.css'
})
export class PharmacistDashboard implements OnInit {
  stock: any[] = [];
  storeId!: number;
  selectedItem: any = null;
  transferQuantity: number = 0;
  toStoreId: number = 0;
  transferNote: string = '';
  otherStores: any[] = [];

  filters = {
    product_name: '',
    category: '',
    unit: '',
    origin: '',
    quantity: null,
    expiry_start: '',
    expiry_end: ''
  };

  constructor(private http: HttpClient) {}

  ngOnInit() {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      console.error('❌ No user object found in localStorage');
      return;
    }

    try {
      const user = JSON.parse(storedUser);
      this.storeId = user?.store_id;

      if (!this.storeId) {
        console.error('❌ No store_id found in parsed user object');
        return;
      }

      this.loadStock();
      this.loadStores();
    } catch (err) {
      console.error('❌ Failed to parse user from localStorage:', err);
    }
  }

  loadStock() {
    this.http.get<any[]>(`${baseUrl}/pharmacist-store/${this.storeId}`)
      .subscribe({
        next: (data) => this.stock = data,
        error: (err) => console.error('❌ Failed to fetch pharmacist store data:', err)
      });
  }

  loadStores() {
    this.http.get<any[]>(`${baseUrl}/stores`).subscribe({
      next: (data) => this.otherStores = data.filter(s => s.id !== this.storeId),
      error: (err) => console.error('❌ Failed to load stores:', err)
    });
  }

  get filteredStock() {
    return this.stock.filter(item => {
      const matchesProduct = !this.filters.product_name || item.product_name?.toLowerCase().includes(this.filters.product_name.toLowerCase());
      const matchesCategory = !this.filters.category || item.category?.toLowerCase().includes(this.filters.category.toLowerCase());
      const matchesUnit = !this.filters.unit || item.unit?.toLowerCase().includes(this.filters.unit.toLowerCase());
      const matchesOrigin = !this.filters.origin || item.from_store?.toLowerCase().includes(this.filters.origin.toLowerCase());
      const matchesQuantity = !this.filters.quantity || item.store_quantity >= this.filters.quantity;

      const expiryDate = new Date(item.expiry_date);
      const matchesStart = !this.filters.expiry_start || expiryDate >= new Date(this.filters.expiry_start);
      const matchesEnd = !this.filters.expiry_end || expiryDate <= new Date(this.filters.expiry_end);

      return matchesProduct && matchesCategory && matchesUnit &&
             matchesOrigin && matchesQuantity && matchesStart && matchesEnd;
    });
  }

  resetFilters() {
    this.filters = {
      product_name: '',
      category: '',
      unit: '',
      origin: '',
      quantity: null,
      expiry_start: '',
      expiry_end: ''
    };
  }

  openTransferModal(item: any) {
    this.selectedItem = item;
    this.transferQuantity = 0;
    this.toStoreId = 0;
    this.transferNote = '';
  }

  closeModal() {
    this.selectedItem = null;
  }

  getStoreNameById(storeId: number): string {
    if (!storeId) return '—';
    const store = [...this.otherStores, { id: this.storeId, name: 'This Store' }]
      .find(s => s.id === storeId);
    return store ? store.name : 'Unknown Store';
  }

  transferItem() {
    if (!this.transferQuantity || !this.toStoreId) {
      alert('Please enter all fields.');
      return;
    }

    const body = {
      stock_item_id: this.selectedItem.stock_item_id,
      quantity: this.transferQuantity,
      from_store_id: this.storeId,
      to_store_id: this.toStoreId,
      note: this.transferNote || ''
    };

    console.log(body);

    this.http.post(`${baseUrl}/store-transfers`, body)
      .subscribe({
        next: () => {
          alert('✅ Transfer complete.');
          this.loadStock();
          this.closeModal();
        },
        error: (err) => {
          console.error('❌ Transfer failed:', err);
          alert('Transfer failed.');
        }
      });
  }
}
